import React, { useState, useContext, useEffect } from "react";
import { Card, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleDown, faTrash } from "@fortawesome/free-solid-svg-icons";
import { currencyFormat, i18nValue } from "../../functions";
import { T } from "react-translator-component";
import { HotelContext } from "../../context/hotel";

const CartSummary = ({
    cart,
    cartItemsCustomizations,
    setCartItemsCustomizations,
    summary,
    // setSummary,
    setOpenModal,
    language,
    observations,
    setObservations,
    handleDeleteItem,
    isEdit = false
}) => {
    const [customizations, setCustomizations] = useState({});
    const { currency } = useContext(HotelContext);

    useEffect(() => {

        console.log('CartSummary - cart', cart);
        console.log('CartSummary - cartItemsCustomizations', cartItemsCustomizations);

        let auxCustomsItems = {};
        cart.items?.map((el) => {
            if (el.customizations) {

                el.customizations.map((item, index) => {
                    Object.keys(item).map((key, idx) => {

                        if (el.preferences?.[key]) {
                            auxCustomsItems = {
                                ...auxCustomsItems,
                                [el.itemId]: {
                                    ...(auxCustomsItems[el.itemId] || {}),
                                    [index]: {
                                        ...(auxCustomsItems[el.itemId]?.[index] || {}),
                                        [key]: item[key],
                                    },
                                },
                            };
                        }
                        
                    });
                });

            }
        });

        setCustomizations(auxCustomsItems);
  
    }, []);

    useEffect(() => {
        console.log('CartSummary - customizations', customizations);
    }, [customizations]);
    
    // const handleClose = () => {
    //     setSummary(false);
    // };

    const handleObservationChange = (e) => {
        setObservations(e.target.value);
    };

    const handleOptionSelect = (itemId, idx, prefId, optId) => {
        setCustomizations((prevCustomizations) => {
            const updatedCustomizations = {
                ...prevCustomizations,
                [itemId]: {
                    ...(prevCustomizations[itemId] || {}),
                    [idx]: {
                        ...(prevCustomizations[itemId]?.[idx] || {}),
                        [prefId]: optId,
                    },
                },
            };

            const transformedCustomizations = Object.keys(updatedCustomizations).reduce(
                (acc, currentItemId) => {
                    const currentItemCustomizations = updatedCustomizations[currentItemId];

                    const currentItemTransformed = Object.keys(
                        currentItemCustomizations
                    ).reduce((itemAcc, currentIdx) => {
                        const currentCustomization = currentItemCustomizations[currentIdx];

                        itemAcc[currentIdx] = currentCustomization;
                        return itemAcc;
                    }, {});

                    acc[currentItemId] = currentItemTransformed;
                    return acc;
                },
                {}
            );
            return transformedCustomizations;
        });
    };

    const handleSummaryDeleteItem = (itemId, index) => {

        // Remuevo customización
        let auxCustomizations = { ...customizations};
        if (auxCustomizations?.[itemId]?.[index]) {
            auxCustomizations[itemId] = removeAndReorder(auxCustomizations[itemId], index);
            setCustomizations(auxCustomizations);
        }

        handleDeleteItem(itemId);
    }

    const removeAndReorder = (obj, keyToRemove) => {
        const updatedObj = {};
        // const targetObj = obj["37bde9b3-5023-441f-8265-e6fc85ba6a8b"];
    
        let index = 0;
        for (const key in obj) {
          if (key != keyToRemove) {
            updatedObj[index] = obj[key];
            index++;
          }
        }
    
        obj = updatedObj;
        return obj;
    }

    return (
        <>
            {summary && cart?.items && (
                <div
                    className="cart-container p-3"
                    style={{
                        position: 'fixed',
                        top: 50,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        zIndex: 999,
                        overflowY: 'auto',
                    }}
                >
                    <div className="cart-label d-flex justify-content-between align-items-center">
                        {/* <div className="cart-title p-2 ">{T('request.your-request')}</div> */}
                        <div className="p-2">
                        <span className="cart-title">{T("request.your-request")}</span>
                        <small clasName="text-muted">{` (${cart?.qty} ${cart?.qty > 1 ? T("request.products") : T("request.product")})`}</small>
                        </div>
                        {/* <Button size="sm" onClick={handleClose}>
                            <FontAwesomeIcon
                                icon={faArrowAltCircleDown}
                                color="white"
                                size="2x"
                            />
                        </Button> */}
                    </div>
                    {cart.items.flatMap((item, idx) =>
                        Array.from({ length: item.qty }, (_, index) => (
                            <Card key={item.itemId + '_' + index} className="my-2">
                                <Card.Body className="p-2">
                                    <div className="p-1">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="general-text text-uppercase">
                                                <small className="cart-title mr-1"><small>#</small>{(idx + 1) + index}</small>
                                                <b>{item.name}</b>
                                            </div>
                                            <button
                                                style={{
                                                    background: "none",
                                                    border: "none",
                                                    width: "20px",
                                                    // height: "20px"
                                                }}
                                                onClick={() => { handleSummaryDeleteItem(item.itemId, index) }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faTrash}
                                                    color="red"
                                                />
                                            </button>
                                        </div>
                                        <div>
                                            <Card.Text>
                                                <span className="general-text text-muted font-size-sm d-block" style={{ lineHeight: 1.25 }}>
                                                    {item.desc}
                                                </span>
                                            </Card.Text>
                                            {item.preferences && Object.keys(item.preferences).map((prefId, idx) => {
                                                const p = item.preferences[prefId];
                                                return (
                                                    <React.Fragment key={prefId}>
                                                        <p className="mb-1 font-size-sm"><b>{i18nValue(p, "title", language)}</b></p>
                                                        <Form.Control
                                                            as={"select"}
                                                            className="mb-2 font-size-sm"
                                                            value={customizations?.[item.itemId]?.[index]?.[prefId] || ""}
                                                            onChange={(event) => {
                                                                handleOptionSelect(
                                                                    item.itemId,
                                                                    index,
                                                                    prefId,
                                                                    event.target.value
                                                                )
                                                            }}
                                                        >
                                                            <option value="">{T("select...")}</option>
                                                            {p.options && Object.keys(p.options).map((optionId) => (
                                                                <option key={optionId} value={optionId}>{i18nValue(p.options[optionId], "value", language)}</option>
                                                            ))}
                                                        </Form.Control>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                        <div className="d-flex flex-column align-items-end">
                                            <span className="general-text text-muted mt-2">
                                                <b>{currencyFormat(item.price, currency)}</b>
                                            </span>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        ))
                    )}
                    <div className="observations p-1">
                        <Form.Label className="cart-label">
                            {T('request.observations')}
                        </Form.Label>
                        <Form.Control
                            className="font-size-sm"
                            as="textarea"
                            rows={3}
                            placeholder={T("request.observations-placeholder")}
                            value={observations || ""}
                            onChange={(e) => {
                                handleObservationChange(e)
                            }}
                        />
                    </div>
                    <div className="subtotal cart-label mt-2 mx-1 font-size-md" style={{ textAlign: 'right', marginBottom: 60 }}>
                        {T('general.total')}: <b>{currencyFormat(cart.total, currency)}</b>
                    </div>
                    <div className="fixed-bottom py-3 px-4" style={{  backgroundColor: "#eaeaea" }}>
                        <Button
                            size={'lg'}
                            variant={'success'}
                            type={'button'}
                            block={true}
                            className={'cart-go-resume'}
                            onClick={() => {
                                setCartItemsCustomizations(customizations)
                                setOpenModal(true);
                            }}
                        >
                            { T(isEdit ? 'general.updateOrder' : 'general.placeOrder') }
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default CartSummary;
